module.exports = __webpack_public_path__ + "static/img/682ac67779a2f17f7a8c1846da7f504a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advant_active_01.png
// module id = iift
// module chunks = 1